import apiClient from '../apiClient';

export function getApiErrorMessage(error, fallback = 'Request failed') {
  try {
    if (error == null) return fallback;
    if (typeof error === 'string' && error.trim()) return error;

    const responseData = error.response && error.response.data;
    if (responseData && typeof responseData.error === 'string' && responseData.error.trim()) {
      return responseData.error;
    }
    if (responseData && typeof responseData.message === 'string' && responseData.message.trim()) {
      return responseData.message;
    }
    if (typeof error.message === 'string' && error.message.trim()) {
      return error.message;
    }
    return fallback;
  } catch (_) {
    return fallback;
  }
}

/**
 * GET /admin/news?page=1&limit=20
 * Response: { data: Article[], pagination: { page, limit, totalCount, totalPages, hasNextPage, hasPrevPage } }
 */
export async function listAdminNews({ page = 1, limit = 20 } = {}) {
  const response = await apiClient.get('/admin/news', {
    params: { page, limit },
  });
  return response.data;
}
